import { authApiBuilder } from './authClient';
import { getIsVirtualRoom } from '../cloudHelper';

let idServiceBaseUrl = import.meta.env.VITE_ID_SERVICE_BASE_URL;
let idServiceAccountsBaseUrl = import.meta.env.VITE_ID_SERVICE_ACCOUNTS_BASE_URL;
let apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
let integrationsBaseUrl = import.meta.env.VITE_INTEGRATIONS_BASE_URL;
let taskDataApiBaseUrl = import.meta.env.VITE_TASK_DATA_API_BASE_URL;
let workspaceWebsocketUrl = import.meta.env.VITE_WEBSOCKET_ENDPOINT;

let taskDataWebsocketUrl: string | undefined;

const { origin, hostname, host } = window.location;
if (hostname !== 'localhost' && getIsVirtualRoom({ origin, hostname })) {
  // virtual control rooms have a unique endpoint
  idServiceBaseUrl = `https://${host}/id-api/${import.meta.env.VITE_ID_SERVICE_API_VERSION}`;
  idServiceAccountsBaseUrl = `https://${host}/accounts-api/${
    import.meta.env.VITE_ACCOUNTS_SERVICE_API_VERSION
  }`;
  apiBaseUrl = `https://${host}/dashboard-api/api`;
  integrationsBaseUrl = `https://${host}/integration-api`;
  taskDataApiBaseUrl = `https://${host}/task-api`;
  workspaceWebsocketUrl = `wss://${host}/dashboard-live`;
  taskDataWebsocketUrl = `wss://${host}/task-data-live`;
}

export const buildIdServiceAPI = authApiBuilder({ url: idServiceBaseUrl });
export const buildIdServiceAccountsAPI = authApiBuilder({ url: idServiceAccountsBaseUrl });
export const buildDashboardAPI = authApiBuilder({ url: apiBaseUrl });

export const buildIntegrationAPI = authApiBuilder({ url: integrationsBaseUrl }, true);
export const buildTaskDataAPI = authApiBuilder({ url: taskDataApiBaseUrl }, true);

export const buildSsoManagementAPI = authApiBuilder(
  { url: import.meta.env.VITE_SSO_MANAGEMENT_API_URL || '' },
  true,
);

export const buildFeedbackAPI = authApiBuilder({ url: `${import.meta.env.VITE_FEEDBACK_API_URL}` });

export const getWorkspaceWebsocketUrl = () => workspaceWebsocketUrl;
export const getActivityRunWebsocketUrl = () => taskDataWebsocketUrl;

export const buildVideoStreamPlaylistUrl = ({
  workspaceId,
  processId,
  processRunId,
  activityRunId,
}: {
  workspaceId: string | undefined;
  processId: string | undefined;
  processRunId: string | undefined;
  activityRunId: string | undefined;
}): string | null => {
  if (
    workspaceId === undefined ||
    processId === undefined ||
    processRunId === undefined ||
    activityRunId === undefined
  ) {
    return null;
  }
  return `${taskDataApiBaseUrl}/json-v1/workspaces/${workspaceId}/processes/${processId}/process-runs/${processRunId}/activity-runs/${activityRunId}/video/stream.m3u8`;
};
